<template>
  <section class="lh-success lh-WrapperSingle">
    <div class="lh-Wrapper">
      <div class="lh-Wrapper-box lh-Wrapper-box--small">
        <div class="lh-Wrapper-boxContent">
          <ul class="lh-Breadcrumb">
            <li class="lh-Breadcrumb-item">
              <router-link class="lh-Breadcrumb-link" to="/"
                >Accueil</router-link
              >
            </li>
            <li class="lh-Breadcrumb-item">
              <a class="lh-Breadcrumb-link">Commande confirmée</a>
            </li>
          </ul>
          <div class="lh-Contact-form">
            <h1 class="lh-Form-title">Merci !</h1>
            <p>
              La commande votre LHight est confirmée.
              <br />
              Vous devriez la recevoir très bientôt :)
            </p>
            <router-link class="lh-Button" to="/boutique"
              >Retour à la boutique</router-link
            >
          </div>
        </div>
      </div>
      <div
        class="lh-Wrapper-box lh-Wrapper-box--big lh-Wrapper-box--transparent"
      ></div>
      <div class="lh-success-bg">
        <span
          class="lh-success-confetti"
          v-for="index in 100"
          :key="index"
          :data-index="index"
        ></span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "success",
  data: () => {
    return {
      confetti: 129,
    };
  },
};
</script>
<style lang="scss">
@import "@/components/success/_index.scss";
</style>
